/*
 * File: base-cell.ts
 * File Created: 2023-12-18 04:45:49
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2025-12-06 10:50:36
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import { BaseComponent } from "@root/components/base-classes";
import { Component, Prop } from "vue-property-decorator";
import { ITableBodyCellAttr } from "../core";
import { IPaging } from "@root/core";

export interface ITableBodyCellData {
    "text-empty": string;
}
export const defaultTableBodyCellData: ITableBodyCellData = {
    "text-empty": "w_CellNullText",
};

/// the base for implement iv-cell-*
@Component
export class BaseTableBodyCell extends BaseComponent implements ITableBodyCellAttr {
    @Prop({ type: Object, required: true })
    paging!: IPaging;

    @Prop({ type: Array, required: true })
    rows!: any[];

    @Prop({ type: Object, required: true })
    row!: any;

    @Prop({ type: Number, required: true })
    index!: number;

    @Prop({ type: String, required: true })
    name!: string;

    /// prepend / append text
    @Prop({ type: String, required: false })
    prepend?: string;

    @Prop({ type: String, required: false })
    append?: string;

    @Prop({ type: Boolean, default: () => false })
    renderWhenEmpty!: boolean;

    /// data helper
    @Prop({ type: Object, required: false })
    declare data: ITableBodyCellData | undefined;
    get mergedData() {
        return {
            ...defaultTableBodyCellData,
            ...this.data,
        };
    }
}
export default BaseTableBodyCell;
